<template>
  <v-dialog
      v-model="showRecommendations"
      persistent
      width="800"
      scrollable
  >
    <v-card>
      <v-card-title class="d-flex justify-content-between">
        Добавить рекомендации
        <button
            @click="close"
            class="close"
        >
          ✖
        </button>
        <v-col cols="12">
          <v-tabs
              v-model="tab"
              bg-color="primary"
              centered
          >
            <template v-for="(type, index) in types" >
              <v-tab
                  :key="index"
                  :value="type">
                {{ ruTags[type] }}
              </v-tab>
            </template>
          </v-tabs>
        </v-col>
      </v-card-title>
      <v-card-text>
        <v-tabs-items v-model="tab">
          <v-tab-item
              v-for="type in types"
              :key="type"
          >
            <v-card flat>
              <v-card-text>
                <v-list-item-group
                    v-model="selected"
                    multiple
                    active-class=""
                >
                  <template v-for="r in recommendations[type]">
                    <span style="position: relative" :key="r.id">
                      <v-list-item
                          :value="r.id"
                      >
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                            <v-checkbox :input-value="active"></v-checkbox>
                          </v-list-item-action>

                          <v-list-item-content>
                            <v-list-item-title> {{ r.title }}</v-list-item-title>
                            <v-list-item-subtitle>{{r.content}}</v-list-item-subtitle>
                          </v-list-item-content>
                      </template>
                    </v-list-item>
                      <span style="z-index: 1080; position: absolute; top:10px; right:10px;">
                         <v-btn-toggle
                             v-model="r.addSide"
                             multiple
                             @change="addOneSide(r)"
                         >
                      <template v-for="(side, index) in addSideText">
                        <v-btn
                            small
                            :key="'side-' + index"
                            @click.prevent
                        >
                          {{ side.text }}
                        </v-btn>
                      </template>
                    </v-btn-toggle>
                       <v-btn
                           depressed
                           small
                           @click.stop="allSides(r)"
                       >
                              все
                            </v-btn>
                      </span>
                    </span>
                  </template>
                </v-list-item-group>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions class="justify-content-around mb-2">
        <v-row>
          <v-col>
            <v-text-field
              v-model="userEdit.content"
              label="Добавить рекомендации"
            />
          </v-col>
          <v-col cols="12" class="d-flex justify-content-around">
            <v-btn @click="close">отмена</v-btn>
            <v-btn @click="saveRecs">добавить</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Recommendations",
  props:  {
    showRecommendations: {
      type: Boolean,
      default: false,
    },
    recFromOrder: {
      type: Array,
      default: () => [],
    },
    recommendationsList: {
      type: Array,
      default: () => [],
    },
    recCats: {
      type: Array,
      default: () => [],
    },
    initRecCats: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      addSideText: [
        {
          text: 'ЛП',
          value: 'ЛП'
        },
        {
          text: 'ПП',
          value: 'ПП'
        },
        {
          text: 'ЗП',
          value: 'ЗП'
        },
        {
          text: 'ЗЛ',
          value: 'ЗЛ'
        },
      ],
      userEdit: {
        "id": 0,
        "type": "userEdit",
        "title": "",
        "content": null,
      },
      selected: [],
      tab: null,
      recommendations: null,
      recommendationsRow: null,
      types: [],
      ruTags: [],
    }
  },
  mounted() {
    let temp = {}
    let rutags = {}
    if (this.recFromOrder && this.recFromOrder.length > 0) {
      this.recFromOrder.forEach((item) => {
        if(item.id==0) {
          this.userEdit.content = item.content
        } else {
          const signed = this.recommendationsList.find((val) => {
            return item.id == val.id
          })
          signed.addSide = item.addSide
          this.selected.push(item.id)
        }
      })
    }
    this.recommendationsList.forEach((item) => {
      if (!item.addSide) item.addSide = []
      if (temp[item.type.toLowerCase()]) {
        temp[item.type.toLowerCase()].push(item);
      } else {
        temp[item.type.toLowerCase()] = []
        temp[item.type.toLowerCase()].push(item);
        rutags[item.type.toLowerCase()] = item.slug_rus.toLowerCase()
      }
    })

    if (this.initRecCats) {
      this.tab = this.initRecCats
    }
    Object.keys(temp).forEach(key => {
      if (this.recCats.includes(key.toLowerCase())) {
        this.types.push(key)
      }
    })
    this.ruTags = rutags
    this.recommendations = temp
    this.recommendationsRow = this.recommendationsList
  },
  methods: {
    allSides (r) {
      console.log(r)
      if (r.addSide.length > 3) {
        r.addSide = []
      } else {
        r.addSide = [0,1,2,3]
      }
      if (!this.selected.includes(r.id)) {
        this.selected.push(r.id)
      }
      this.recommendations = JSON.parse(JSON.stringify(this.recommendations))
    },
    addOneSide (r) {
      console.log()
      if (!this.selected.includes(r.id)) {
        this.selected.push(r.id)
      }
      this.recommendations = JSON.parse(JSON.stringify(this.recommendations))
    },
    saveRecs () {
      const recSel = []
      this.selected.forEach((item) => {
        const sr = JSON.parse(JSON.stringify(this.recommendationsRow.find(r => r.id === item)))
        if(sr.addSide.length > 0  && sr.addSide.length < 4) {
          const sidesTextArr = []
          sr.addSide.forEach(item => {
            sidesTextArr.push(this.addSideText[item].text)
          })
          sr.title = sr.title + ' ' + sidesTextArr.join(',')
        }
        recSel.push(sr)
      })
      if (this.userEdit.content) recSel.push(this.userEdit)
      this.$emit('saveRec', recSel)
    },
    close () {
      this.$emit('closeRec')
    }
  }
}
</script>